import i18n from "../localization/i18n";
import store from "../ApplicationStore";
import { showMessage } from "../redux/AppAction";
import { AlertTypes, WebUrl } from "./Constant";

export const GAME_LAUNCH_ERROR_MESSAGE = "game-launch-error";

// Keep paths in sync with GameLaunchErrorPage.cs.
const GAME_LAUNCH_ERRORS = {
    CATEGORY_NOT_IN_PROMOTION: { buttonKey: "BACK" },
    PROVIDER_NOT_IN_PROMOTION: { buttonKey: "BACK" },
    SPECIAL_GAMES_FOR_PROMOTION: { buttonKey: "GO_TO_PROMOTIONS", path: WebUrl._URL_PROMOTION },
    FORCE_WITHDRAW_WARNING: { buttonKey: "WITHDRAW", path: WebUrl._URL_WITHDRAWAL },
    MEMBER_IS_BLOCKED: { buttonKey: "CONTACT", path: WebUrl._URL_LIVE_CHAT },
    REGISTRATION_FAILED: { buttonKey: "CONTACT", path: WebUrl._URL_LIVE_CHAT },
    PLEASE_CONTACT_CS: { buttonKey: "CONTACT", path: WebUrl._URL_LIVE_CHAT },
    ACCOUNT_LOCKED_ERROR: { buttonKey: "CONTACT", path: WebUrl._URL_LIVE_CHAT },
    PROVIDER_UM_ERROR: { buttonKey: "BACK" },
    FAILED_TO_LAUNCH_PAGE: { buttonKey: "BACK" },
    GAME_UNAVAILABLE_ERROR: { buttonKey: "BACK" },
};

function copy(key) {
    return i18n.getResource(i18n.language, "common", key) || "";
}

function localePath(path) {
    const stored = localStorage.getItem("language") || "en";
    const first = window.location.pathname.split("/").filter(Boolean)[0];
    const locale = first && first !== "Game" && first.length <= 8 ? first : stored;
    return `/${locale}${path}`;
}

export function showGameLaunchError(key) {
    const spec = GAME_LAUNCH_ERRORS[key] || GAME_LAUNCH_ERRORS.GAME_UNAVAILABLE_ERROR;
    const resolvedKey = GAME_LAUNCH_ERRORS[key] ? key : "GAME_UNAVAILABLE_ERROR";
    const title = copy(`GAME_LAUNCH_${resolvedKey}_TITLE`);
    const body = copy(`GAME_LAUNCH_${resolvedKey}_BODY`) || i18n.t(resolvedKey);

    store.dispatch(showMessage({
        type: AlertTypes._ERROR,
        title,
        html: body,
        confirmBtnText: i18n.t(spec.buttonKey),
        onConfirm: () => {
            if (spec.path) {
                window.location.assign(localePath(spec.path));
            }
        },
    }));
}
